// src/plugins/share.ts
// 用户信息

// 获取当前页面路径
const getCurrentPageUrl = () => {
  const pages = getCurrentPages()
  const currentPage = pages[pages.length - 1]
  return currentPage.route
}

// 获取当前页面的参数
const getCurrentPageOptions = () => {
  const pages = getCurrentPages()
  const currentPage = pages[pages.length - 1]
  const options = currentPage.options || {}
  return options
}

const share = {
  // 分享到好友
  onShareAppMessage() {
    let currentPageUrl = getCurrentPageUrl()
    console.log('🚀 ~ onShareAppMessage ~ currentPageUrl:', currentPageUrl)
    const options = getCurrentPageOptions()
    const query = Object.entries(options)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('&')
    console.log('Current Page URL:', currentPageUrl) // 调试信息
    console.log('Query:', query) // 调试信息
    return {
      title: '跨界免息分期·机票酒店用车旅游', // 分享标题
      path: `/${currentPageUrl}?${query}`, // 分享路径
      imageUrl: '', // 分享图片
    }
  },

  // 分享到朋友圈
  onShareTimeline() {
    const currentPageUrl = getCurrentPageUrl()
    const options = getCurrentPageOptions()
    const query = Object.entries(options)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('&')
    return {
      title: '跨界免息分期·机票酒店用车旅游', // 分享标题
      query: `path=${currentPageUrl}&${query}`, // 分享路径参数
      imageUrl: '', // 分享图片
    }
  },
}

export default share
